import React from "react";
import {ModalWindow} from "../../modal/ModalWindow";
import {FacebookIntegration} from "./FacebookIntegration";

export function FacebookConnectModal({onClose}: { onClose: () => void }) {
    return <ModalWindow
        width={520}
        title={"Facebook Page connection"}
        onClose={onClose}
    >
        <FacebookIntegration compact/>
    </ModalWindow>
}
